<template>
  <div ref="wrapper" class="scroll_wrapper">
    <div class="scroll_content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  import BScroll from "better-scroll";
  import {SCROLL_CONFIG} from "@/store/constant";

  export default {
    name: "Scroll"
    , methods: {
      initScroll() {
        new BScroll(this.$refs.wrapper, SCROLL_CONFIG)
      }
    }
    , mounted() {
      setTimeout(() => {
        this.initScroll()
      }, 20)
    }
  }
</script>

<style lang="scss" scoped>
  .scroll_wrapper {
    position: relative;
    height: 100%;
    overflow: hidden;
  }
</style>